import { Injectable } from '@angular/core';
import { ProdutosModel } from '@app/data/models';
import { CartItem } from '@app/pages/cart/cart.interface';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CartService {
  public readonly cartItemsSubject: BehaviorSubject<CartItem[]> = new BehaviorSubject<CartItem[]>([]);
  cartItems$: Observable<CartItem[]> = this.cartItemsSubject.asObservable();
  private readonly CART_STORAGE_KEY = 'cart_items';

  constructor() {
    this.loadCartFromStorage();
  }

  private loadCartFromStorage(): void {
    const storedItems = localStorage.getItem(this.CART_STORAGE_KEY);
    if (storedItems) {
      const items: CartItem[] = JSON.parse(storedItems);
      this.cartItemsSubject.next(items);
    }
  }

  public saveCartToStorage(items: CartItem[]): void {
    localStorage.setItem(this.CART_STORAGE_KEY, JSON.stringify(items));
  }

  public addToCart(item: ProdutosModel | CartItem, quantidade: number = 1): void {
    const currentItems: CartItem[] = this.cartItemsSubject.getValue();
    const itemId = 'imagens' in item ? item.id : item.id;
    const existingItemIndex = currentItems.findIndex((cartItem: CartItem) => cartItem.id === itemId);

    if (existingItemIndex !== -1) {
      currentItems[existingItemIndex] = {
        ...currentItems[existingItemIndex],
        quantidade: quantidade,
      };
    } else {
      const newItem: CartItem =
        'imagens' in item
          ? {
              id: item.id,
              descricao: item.descricao,
              imagem: item.imagens[0].id,
              quantidade: quantidade,
              unitario: item.unitario,
            }
          : {
              ...item,
              quantidade: quantidade,
            };
      currentItems.push(newItem);
    }

    this.cartItemsSubject.next([...currentItems]);
    this.saveCartToStorage(this.cartItemsSubject.getValue());
  }

  getCartItemsCount(): number {
    const currentCartItems: CartItem[] = this.cartItemsSubject.getValue();
    return currentCartItems.length;
  }

  getTotalItemsCount(): number {
    const currentCartItems: CartItem[] = this.cartItemsSubject.getValue();
    return currentCartItems.reduce((total: number, item: CartItem) => total + item.quantidade, 0);
  }

  clearCart(): void {
    this.cartItemsSubject.next([]);
    this.saveCartToStorage([]);
  }

  getCartItems(): Observable<CartItem[]> {
    return this.cartItems$;
  }

  removeFromCart(id: string) {
    const currentCartItems: CartItem[] = this.cartItemsSubject.getValue();
    const updatedCartItems: CartItem[] = currentCartItems.filter((item: CartItem) => item.id !== id);
    this.cartItemsSubject.next(updatedCartItems);
    this.saveCartToStorage(updatedCartItems);
  }
}
